const stepRegistry = {};

function resolve(key) {
  if (!stepRegistry[key]) {
    throw new Error(`Trying to get invalid step with key: ${key}`);
  }
  return stepRegistry[key];
}

function register(key, Component) {
  stepRegistry[key] = Component;
}

const registry = { resolve, register };

export default registry;
